import React from "react";
import { Routes, Route } from "react-router-dom";

import "../App.css";

import Home from "../pages/landingPage/Home";

import Hero from "../pages/landingPage/Hero";
import About from "../pages/About";
import Contact from "../pages/Contact";
import LandscapingDesignBuild from "../pages/services/LandscapingDesignBuild";
import Hydroseeding from "../pages/services/Hydroseeding";
import WashingWaterBlasting from "../pages/services/WashingWaterBlasting";
import PropertyMaintenance from "../pages/services/PropertyMaintenance";
import LawnMaintenance from "../pages/services/LawnMaintenance";
import Fencing from "../pages/services/Fencing";

import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";



function App() {
  return (
    <>
      <ScrollToTop/>
      <Navbar />
      <Routes>
        {/* LANDING PAGES */}
        <Route path="/" element={<Hero />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/landscaping-design-build" element={<LandscapingDesignBuild />} />
        <Route path="/hydroseeding" element={<Hydroseeding />} />
        <Route path="/washing-water-blasting" element={<WashingWaterBlasting />} />
        <Route path="/property-maintenance" element={<PropertyMaintenance />} />
        <Route path="/lawn-maintenance" element={<LawnMaintenance />} />
        <Route path="/fencing" element={<Fencing />} />

        
        <Route path="/home" element={<Home />} />

      

      </Routes>
      <Footer />
    </>
  );
}

export default App;
